import { compact, isPlainObject, isString } from 'lodash-es';

export default (user, defaultName = 'Anonymous') => {
  if (!isPlainObject(user) || !isString(user.firstname) || !isString(user.lastname)) {
    return defaultName;
  }

  return compact([user.firstname, user.lastname]).join(' ');
};
